module.exports = {"buildTime":"2021-09-16 11:55:18"}


//////////////////
// WEBPACK FOOTER
// P:/Work/htdocs/biatlon/online/src/components/utils/.env.json
// module id = 705
// module chunks = 0